import React from 'react';

const ContentSection = ({children, className = ''}) => (
    <section className={`content-section${className && ' ' + className}`}>{children}</section>
);

export default ContentSection;